interface ILookupTable {
	id: VerificationClientStatus;
	name: string;
}
export const VAClientStatusLookupTable: ILookupTable[] = [
	{ id: 1, name: 'Enquiry Received' },
	{ id: 2, name: 'Application' },
	{ id: 3, name: 'Proposal' },
	{ id: 4, name: 'Risk Assessment' },
	{ id: 5, name: 'Verification Agreement' },
	{ id: 6, name: 'Invoice' },
	{ id: 7, name: 'Verification Progress' },
	{ id: 8, name: 'Wrap-Up' },
];

export enum VerificationClientStatus {
	Enquiry_Received = 1,
	Application = 2,
	Proposal = 3,
	Risk_Assessment = 4,
	Verification_Agreement = 5,
	Invoice = 6,
	Verification_Progress = 7,
	Wrap_Up = 8
}

export enum VerificationClientStatusState{
	Not_Applicable = 0,
	Not_Started = 1, 
	In_Progress_Stage_1 = 2,
	In_Progress_Stage_2 = 3,
	Complete = 4,
	Terminated = 5
}

export const vaClientStatusLookupName = (
	sourceCodeId: VerificationClientStatus
) => {
	let item = VAClientStatusLookupTable.find((x) => x.id === sourceCodeId)!;
	return item.name;
};
